export default {
  foundationOfTheCompany: {
    chapter: '1',
    component: 'helmi-section',
    props: {
      label: 'Yhtiö',
    },
    children: {
      foundedBefore1992: {
        chapter: '1.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Yhtiö perustettu ennen 1.1.1992',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },
    },
  },

  reportedArea: {
    chapter: '2',
    component: 'helmi-section',
    props: {
      label: 'Ilmoitettu pinta-ala',
    },
    children: {
      areaIs: {
        component: 'helmi-subheader',
        props: {
          label: 'Ilmoitettu pinta-ala on',
        },
      },
      superintendentCertificate: {
        chapter: '2.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Isännöitsijäntodistuksen mukainen',
        },
        value: 'Ei',
      },
      articlesOfAssociation: {
        chapter: '2.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Yhtiöjärjestyksen mukainen',
        },
        value: 'Ei',
      },
      clientReport: {
        chapter: '2.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantajan ilmoittama',
        },
        value: 'Ei',
      },
      reviewMeasured: {
        chapter: '2.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Tarkistusmitattu',
        },
        value: 'Ei',
      },
    },
  },

  apartmentManagementCriterion: {
    chapter: '3',
    component: 'helmi-section',
    props: {
      label: 'Asunnon hallintaperuste',
    },
    children: {
      articlesOfAssociation2: {
        chapter: '3.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Yhtiöjärjestyksen mukainen',
        },
        value: 'Ei',
      },

      apartmentManagementCriterionOther: {
        chapter: '3.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muu hallintaperuste',
          type: 'text',
        },
        value: null,
      },
    },
  },

  apartmentManagementCriterionOccupant: {
    chapter: '4',
    component: 'helmi-section',
    props: {
      label: 'Asukkaan käytössä olevien tilojen (esim autopaikka tai varastotilat) hallintaperuste',
    },
    children: {
      articlesOfAssociationOccupant: {
        chapter: '4.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Yhtiöjärjestyksen mukainen',
        },
        value: 'Ei',
      },

      apartmentManagementCriterionOccupantOther: {
        chapter: '4.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muu hallintaperuste',
          type: 'text',
        },
        value: null,
      },
    },
  },

  limitations: {
    chapter: '5',
    component: 'helmi-section',
    props: {
      label: 'Muut käyttörajoitukset',
    },
    children: {
      otherUsageAndReleaseLimitations: {
        chapter: '5.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut käyttörajoitukset',
        },
        value: null,
      },
    },
  },

  performedMeasurementsAndSurveys: {
    chapter: '6',
    component: 'helmi-section',
    props: {
      label: 'Huoneiston kunto ja korjaustarpeet',
    },
    children: {
      humidityMeasurementAndConditionSurvey: {
        chapter: '6.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Suoritettu kosteusmittaus / kuntotarkastus',
        },
        value: null,
      },

      longTermPlan: {
        chapter: '6.2',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'PTS',
        },
        value: null,
      },

      repairNeedsAndUpcomingRenovations: {
        chapter: '6.3',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          hint: 'Rakennuksessa havaitut puutteelliset, virheellisyydet, korjaustarpeet tai suoritetut korjaukset/remontit ja tiedossa olevat mahdolliset tulevat korjaukset/remontit',
          label: 'Rakennuksessa havaitut puutteet ja tiedossa olevat korjaukset',
        },
        value: null,
      },

      renovationsApprovedByTheGeneralMeeting: {
        chapter: '6.4',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Korjauksista / remonteista yhtiökokouksen päätös',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      subsequentCosts: {
        chapter: '6.5',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kustannuksia myöhemmin aiheuttavat yhtiön velvoitteet esim. autopaikat',
        },
        value: null,
      },

      clientMadeRenovations: {
        chapter: '6.6',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja tehnyt huoneistossa muutostöitä',
        },
        value: null,
      },

      managerOrCompanyHasBeenInformed: {
        chapter: '6.7',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muutostöistä ilmoitettu taloyhtiölle/isännöitsijälle',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      clientKnowsOrSuspects: {
        chapter: '6.8',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Toimeksiantaja tietää tai epäilee, että huoneistossa tai taloyhtiössä on',
        },
      },

      waterDamage: {
        chapter: '6.8.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Sattunut vesivahinko',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      moistureDamage: {
        chapter: '6.8.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kosteusvaurioita',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      moldOrFungus: {
        chapter: '6.8.3',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Home- tai sieniongelma',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      otherDamageOrDeficiencies: {
        chapter: '6.8.4',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muita erityisiä vahinkoja, vikoja tai puutteita',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      additionalInfoOfTheDeficiencies: {
        chapter: '6.8.5',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          hint: 'Vahingon ajankohta, laajuus, syy jne.',
          label: 'Lisätietoja vioista ja puutteista',
        },
        value: null,
      },
    },
  },

  keys: {
    chapter: '7',
    component: 'helmi-section',
    props: {
      label: 'Avaimet',
    },
    children: {
      keysSub1: {
        component: 'helmi-subheader',
        props: {
          label: 'Avainten lukumäärä',
        },
      },
      numberOfKeys: {
        chapter: '7.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Toimeksiantajan hallussa olevia käyttölukon avaimia',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      numberOfKeysHandedOver: {
        chapter: '7.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Huoneistoon on taloyhtiön toimesta luovutettu avaimia',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      numberOfKeysToTheSafetyLock: {
        chapter: '7.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Turvalukko ja sen avainten lukumäärä',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      otherKeys: {
        chapter: '7.4',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          hint: 'esim. yleisten tilojen avain tms.',
          label: 'Muut avaimet',
          type: 'text',
        },
        value: null,
      },

      agentReceivedKeyData: {
        chapter: '7.5',
        component: 'helmi-date-picker',
        container: {
          cols: 12,
        },
        props: {
          label: 'Välittäjä vastaanottanut avaimen',
          type: 'text',
          appendIcon: 'today',
        },
        value: null,
      },

      keysSub2: {
        component: 'helmi-subheader',
        props: {
          label: 'Avainten tilaaminen',
        },
      },

      keysMustBeOrderedThroughTheManager: {
        chapter: '7.6',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Avaimet tilattava isännöitsijän kautta',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },
    },
  },

  otherImportantInfo: {
    chapter: '8',
    component: 'helmi-section',
    props: {
      label: 'Lisätiedot',
    },
    children: {
      includedInTheDeal: {
        chapter: '8.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Lisätiedot',
        },
        value: null,
      },
    },
  },

  attachments: {
    chapter: '9',
    component: 'helmi-section',
    props: {
      label: 'Liitteet',
    },
    children: {
      attachments_1: {
        chapter: '9.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Liitteet',
        },
        value: null,
      },
    },
  },
};
